import { Injectable, Injector, RendererFactory2 } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ComponentLoaderFactory } from 'ngx-bootstrap/component-loader';

@Injectable()
export class ModalService {
  public constructor(
    private rendererFactory: RendererFactory2,
    private bsModalService: BsModalService,
    private injector: Injector,
  ) {}

  public getBsModalServiceInstance(): BsModalService {
    let bsModalServiceInstance = this.bsModalService;
    if (this.bsModalService.getModalsCount() > 0) {
      const clf = this.injector.get(ComponentLoaderFactory);
      bsModalServiceInstance = new BsModalService(this.rendererFactory, clf);
    }

    return bsModalServiceInstance;
  }
}
